(function () {
  if (window.__fyhPreorderInitialized) return;
  window.__fyhPreorderInitialized = true;

  const loader = document.querySelector('[data-fyh-loader]');
  const section = document.querySelector('[data-fyh-preorder], [data-fyh-maintenance]');
  const loaderStartedAt = Date.now();
  const MIN_LOADER_MS = 300;
  let loadingFinished = false;

  function revealPage() {
    if (!loader) {
      document.documentElement.classList.remove('fyh-is-loading');
      if (section) section.classList.add('is-ready');
      return;
    }

    loader.classList.add('is-transitioning');
    loader.setAttribute('aria-hidden', 'true');

    window.setTimeout(function () {
      loader.classList.add('is-hidden');
      document.documentElement.classList.remove('fyh-is-loading');
      if (section) section.classList.add('is-ready');
    }, 500);
  }

  function finishLoading() {
    if (loadingFinished) return;
    loadingFinished = true;

    const elapsed = Date.now() - loaderStartedAt;
    const delay = Math.max(0, MIN_LOADER_MS - elapsed);
    window.setTimeout(revealPage, delay);
  }

  function checkContentLoaded() {
    const main = document.getElementById('MainContent');
    const images = main ? main.querySelectorAll('img') : [];
    let imagesLoaded = 0;

    if (images.length === 0) {
      finishLoading();
      return;
    }

    images.forEach(function (img) {
      if (img.complete) {
        imagesLoaded += 1;
      } else {
        img.addEventListener(
          'load',
          function () {
            imagesLoaded += 1;
            if (imagesLoaded === images.length) {
              finishLoading();
            }
          },
          { once: true }
        );
        img.addEventListener(
          'error',
          function () {
            imagesLoaded += 1;
            if (imagesLoaded === images.length) {
              finishLoading();
            }
          },
          { once: true }
        );
      }
    });

    if (imagesLoaded === images.length) {
      finishLoading();
    }
  }

  if (loader) {
    window.setTimeout(checkContentLoaded, 200);
    window.setTimeout(finishLoading, 3000);
  } else {
    document.documentElement.classList.remove('fyh-is-loading');
    if (section) section.classList.add('is-ready');
  }

  if (!section) return;

  const productForms = section.querySelectorAll('.fyh-preorder__product-form');

  const navToggle = section.querySelector('[data-fyh-nav-toggle]');
  const navWrapper = section.querySelector('[data-fyh-nav-mobile-wrapper]');
  const navIconMenu = section.querySelector('[data-fyh-nav-icon-menu]');
  const navIconClose = section.querySelector('[data-fyh-nav-icon-close]');
  const navMobileLinks = section.querySelectorAll('[data-fyh-nav-mobile-link]');

  const accordionItems = section.querySelectorAll('.fyh-preorder__accordion');

  let imageTransitionTimer = null;

  function setNavOpen(isOpen) {
    if (!navWrapper || !navToggle) return;

    navWrapper.classList.toggle('is-open', isOpen);
    navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    navToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');

    if (navIconMenu) navIconMenu.hidden = isOpen;
    if (navIconClose) navIconClose.hidden = !isOpen;
  }

  if (navToggle && navWrapper) {
    navToggle.addEventListener('click', function () {
      setNavOpen(!navWrapper.classList.contains('is-open'));
    });
  }

  navMobileLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      setNavOpen(false);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setNavOpen(false);
  });

  accordionItems.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;

      accordionItems.forEach(function (other) {
        if (other !== details) {
          other.removeAttribute('open');
        }
      });
    });
  });

  section.addEventListener('click', function (event) {
    const thumb = event.target.closest('.fyh-preorder__thumb');
    if (!thumb || !section.contains(thumb)) return;

    const preview = section.querySelector('[data-fyh-preview-image]');
    const src = thumb.getAttribute('data-fyh-thumb-src');
    const alt = thumb.getAttribute('data-fyh-thumb-alt');

    if (!preview || !src || thumb.classList.contains('is-active')) return;

    section.querySelectorAll('.fyh-preorder__thumb').forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-current', 'false');
    });
    thumb.classList.add('is-active');
    thumb.setAttribute('aria-current', 'true');

    if (imageTransitionTimer) clearTimeout(imageTransitionTimer);

    preview.classList.add('is-hidden');
    imageTransitionTimer = setTimeout(function () {
      preview.src = src;
      preview.alt = alt || '';
      preview.classList.remove('is-hidden');
    }, 200);
  });

  productForms.forEach(function (form) {
    bindCheckoutForm(form);
  });

  if (section.hasAttribute('data-fyh-preorder')) {
    enrichProductDisplay(productForms.length === 0);
  }

  function shopifyRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'EUR',
      }).format(cents / 100);
    } catch (error) {
      return '€' + (cents / 100).toFixed(2);
    }
  }

  function bindCheckoutForm(form) {
    const submitButton = form.querySelector('[type="submit"]');
    const checkoutDirect = form.dataset.checkoutDirect !== 'false';
    const errorEl = form.querySelector('[data-fyh-form-error]');

    form.addEventListener('submit', function (event) {
      if (!checkoutDirect) return;

      event.preventDefault();

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      const root = shopifyRoot();
      const addUrl = root.replace(/\/?$/, '/') + 'cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: new FormData(form),
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) {
              throw new Error(payload.description || payload.message || 'Unable to start checkout.');
            }
            return payload;
          });
        })
        .then(function () {
          window.location.href = root.replace(/\/?$/, '/') + 'checkout';
        })
        .catch(function (error) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = error.message || 'Unable to start checkout.';
          }

          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        });
    });
  }

  function getShoppingBagIcon() {
    const template = document.getElementById('fyh-shopping-bag-icon');
    if (template && template.content.firstElementChild) {
      return template.content.firstElementChild.cloneNode(true);
    }

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'fyh-preorder__button-icon');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'currentColor');
    svg.setAttribute('aria-hidden', 'true');

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('fill-rule', 'evenodd');
    path.setAttribute('clip-rule', 'evenodd');
    path.setAttribute(
      'd',
      'M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 0 0 4.25 22.5h15.5a1.875 1.875 0 0 0 1.865-2.071l-1.263-12a1.875 1.875 0 0 0-1.865-1.679H16.5V6a4.5 4.5 0 1 0-9 0ZM12 3a3 3 0 0 0-3 3v.75h6V6a3 3 0 0 0-3-3Zm-3 8.25a3 3 0 1 0 6 0v-.75a.75.75 0 0 1 1.5 0v.75a4.5 4.5 0 1 1-9 0v-.75a.75.75 0 0 1 1.5 0v.75Z'
    );
    svg.appendChild(path);
    return svg;
  }

  function ensureButtonIcon(button, label) {
    const icon = button.querySelector('.fyh-preorder__button-icon');
    const buttonLabel = label || button.textContent.trim();

    if (icon && icon.getAttribute('viewBox') === '0 0 24 24' && icon.querySelector('path[d*="M7.5 6"]')) {
      return;
    }

    button.replaceChildren();
    button.appendChild(getShoppingBagIcon());
    button.appendChild(document.createTextNode(buttonLabel));
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    if (url.startsWith('//')) return 'https:' + url;
    return url;
  }

  function withImageSize(url, size) {
    const normalized = normalizeImageUrl(url);
    if (!normalized) return '';
    const separator = normalized.includes('?') ? '&' : '?';
    return normalized + separator + size;
  }

  function updateProductGallery(product) {
    const images = product.images || [];
    if (images.length === 0) return;

    const preview = section.querySelector('[data-fyh-preview-image]');
    const thumbsContainer = section.querySelector('[data-fyh-thumbs]');
    if (!preview || !thumbsContainer) return;

    const title = product.title || '';
    const firstImage = withImageSize(images[0], 'width=1600');

    preview.hidden = false;
    preview.src = firstImage;
    preview.alt = title;

    thumbsContainer.replaceChildren();

    images.forEach(function (imageSrc, index) {
      const fullSrc = withImageSize(imageSrc, 'width=1600');
      const thumbSrc = withImageSize(imageSrc, 'width=144&height=144&crop=center');

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fyh-preorder__thumb' + (index === 0 ? ' is-active' : '');
      button.setAttribute('data-fyh-thumb', String(index));
      button.setAttribute('data-fyh-thumb-src', fullSrc);
      button.setAttribute('data-fyh-thumb-alt', title);
      button.setAttribute('aria-label', title);
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');

      const thumbImg = document.createElement('img');
      thumbImg.src = thumbSrc;
      thumbImg.alt = '';
      thumbImg.width = 72;
      thumbImg.height = 72;
      thumbImg.loading = 'lazy';

      button.appendChild(thumbImg);
      thumbsContainer.appendChild(button);
    });
  }

  function updateProductDescription(product) {
    if (!product.description) return;

    let descriptionEl = section.querySelector('[data-fyh-description]');
    if (!descriptionEl) {
      const cta = section.querySelector('.fyh-preorder__cta');
      const infoCol = section.querySelector('.fyh-preorder__info-col');
      if (!infoCol) return;

      descriptionEl = document.createElement('div');
      descriptionEl.className = 'fyh-preorder__description fyh-preorder__description--rte rte';
      descriptionEl.setAttribute('data-fyh-description', '');

      if (cta) {
        cta.insertAdjacentElement('afterend', descriptionEl);
      } else {
        infoCol.appendChild(descriptionEl);
      }
    }

    descriptionEl.innerHTML = product.description;
    descriptionEl.classList.add('fyh-preorder__description--rte', 'rte');
  }

  function enrichProductDisplay(needsForm) {
    const handle = section.getAttribute('data-fyh-product-handle');
    if (!handle) return;

    const cta = section.querySelector('.fyh-preorder__cta');
    if (!cta) return;

    const root = shopifyRoot().replace(/\/?$/, '/');
    const buttonLabel = section.getAttribute('data-fyh-button-label') || 'Pre-order';
    const checkoutDirect = section.getAttribute('data-fyh-checkout-direct') !== 'false';

    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product not found');
        }
        return response.json();
      })
      .then(function (product) {
        const variant = product.variants.find(function (item) {
          return item.available;
        }) || product.variants[0];

        if (!variant) return;

        const priceEl = section.querySelector('[data-fyh-price]');
        if (priceEl) {
          priceEl.hidden = false;
          priceEl.textContent = formatMoney(variant.price, product.currency);
        }

        const titleEl = section.querySelector('.fyh-preorder__title');
        if (titleEl && product.title) {
          titleEl.textContent = product.title;
        }

        const artistEl = section.querySelector('.fyh-preorder__artist');
        if (artistEl && product.vendor) {
          artistEl.textContent = product.vendor;
        }

        updateProductDescription(product);
        updateProductGallery(product);

        section.querySelectorAll('.fyh-preorder__button').forEach(function (button) {
          ensureButtonIcon(button, buttonLabel);
        });

        if (!needsForm || cta.querySelector('.fyh-preorder__product-form')) {
          return;
        }

        const setupNotice = cta.querySelector('.fyh-preorder__setup-notice');
        if (setupNotice) setupNotice.remove();

        const form = document.createElement('form');
        form.className = 'fyh-preorder__product-form';
        form.dataset.checkoutDirect = checkoutDirect ? 'true' : 'false';

        const variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        variantInput.value = String(variant.id);

        const quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        quantityInput.value = '1';

        const errorEl = document.createElement('div');
        errorEl.className = 'fyh-preorder__form-error';
        errorEl.setAttribute('data-fyh-form-error', '');
        errorEl.hidden = true;
        errorEl.setAttribute('role', 'alert');

        const button = document.createElement('button');
        button.type = 'submit';
        button.name = 'add';
        button.className = 'fyh-preorder__button';
        button.appendChild(getShoppingBagIcon());
        button.appendChild(document.createTextNode(buttonLabel));

        form.appendChild(variantInput);
        form.appendChild(quantityInput);
        form.appendChild(errorEl);
        form.appendChild(button);
        cta.appendChild(form);

        bindCheckoutForm(form);
      })
      .catch(function () {
        /* Keep existing content when the product cannot be loaded. */
      });
  }
})();
